// P3-021: Screen-level visual effects
// Overload glitch effect (scan lines), skill trigger flash

import Phaser from 'phaser';

/**
 * Play an overload glitch effect: horizontal scan lines + screen shake.
 * Used when hardware overload triggers "algorithm fluctuation".
 */
export function playOverloadGlitch(scene: Phaser.Scene): void {
  const { width, height } = scene.scale;

  // Scan lines overlay
  const scanLines = scene.add.graphics();
  scanLines.setDepth(98);
  scanLines.fillStyle(0xff0000, 0.08);

  for (let y = 0; y < height; y += 4) {
    scanLines.fillRect(0, y, width, 2);
  }

  // Random noise blocks
  const noiseGraphics = scene.add.graphics();
  noiseGraphics.setDepth(97);
  for (let i = 0; i < 12; i++) {
    const nx = Math.random() * width;
    const ny = Math.random() * height;
    const nw = 20 + Math.random() * 80;
    const nh = 2 + Math.random() * 6;
    noiseGraphics.fillStyle(0xffffff, 0.05 + Math.random() * 0.1);
    noiseGraphics.fillRect(nx, ny, nw, nh);
  }

  // Camera shake
  scene.cameras.main.shake(300, 0.005);

  // Fade out and destroy
  scene.tweens.add({
    targets: [scanLines, noiseGraphics],
    alpha: 0,
    duration: 600,
    delay: 200,
    ease: 'Sine.easeOut',
    onComplete: () => {
      scanLines.destroy();
      noiseGraphics.destroy();
    },
  });
}

/**
 * Play a skill trigger flash (generic version).
 * Brief bright flash centered on a position.
 */
export function playSkillFlash(
  scene: Phaser.Scene,
  worldX: number,
  worldY: number,
  color = 0xe6a640,
): void {
  const flash = scene.add.graphics();
  flash.setDepth(96);

  // Radial glow circle
  flash.fillStyle(color, 0.4);
  flash.fillCircle(worldX, worldY, 40);
  flash.fillStyle(color, 0.2);
  flash.fillCircle(worldX, worldY, 70);

  scene.tweens.add({
    targets: flash,
    alpha: 0,
    scaleX: 1.5,
    scaleY: 1.5,
    duration: 350,
    ease: 'Sine.easeOut',
    onComplete: () => {
      flash.destroy();
    },
  });

  // Brief camera flash
  scene.cameras.main.flash(150, 255, 255, 255, false, undefined, undefined);
}
